import React from 'react';

const svgProps = {
  className: 'nav-tab-icon-svg',
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  'aria-hidden': true,
  focusable: false,
};

export function FriendsNavIcon() {
  return (
    <svg {...svgProps}>
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="8" cy="8" r="3.2" />
        <path d="M4 20.5v-.5a4 4 0 0 1 8 0v.5" />
        <circle cx="17" cy="8" r="3.2" />
        <path d="M13 20.5v-.5a4 4 0 0 1 8 0v.5" />
      </g>
    </svg>
  );
}

export function SettingsNavIcon() {
  return (
    <svg {...svgProps}>
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="4" y1="21" x2="4" y2="15.5" />
        <line x1="4" y1="10.5" x2="4" y2="3" />
        <circle cx="4" cy="13" r="2.25" />
        <line x1="12" y1="21" x2="12" y2="12.5" />
        <line x1="12" y1="7.5" x2="12" y2="3" />
        <circle cx="12" cy="10" r="2.25" />
        <line x1="20" y1="21" x2="20" y2="17.5" />
        <line x1="20" y1="12.5" x2="20" y2="3" />
        <circle cx="20" cy="15" r="2.25" />
      </g>
    </svg>
  );
}
